var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ChevronRightSvg from './chevron-right.icon.svg';
export const ChevronRightIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: ChevronRightSvg });
};
_react_refresh_temp_1 = ChevronRightIcon;
$RefreshReg$(_react_refresh_temp_1, "ChevronRightIcon");
